import "./productPrice.scss";

import React from "react";
import { ICurrentPrice } from "@sbi-international/boutik.gatsby.plugin.services";
import { useTranslation } from "react-i18next";

type ProductPriceProps = {
    currentPrice?: ICurrentPrice;
    prefixClassName?: string;
};

export function ProductPrice(props: ProductPriceProps) {
    const { currentPrice, prefixClassName } = props;

    const { t } = useTranslation('boutik-gatsby-plugin-components-product-price');

    const isdiscount =
        currentPrice?.discount?.amountOff != 0 || currentPrice?.discount?.percentOff != 0;

    if (!currentPrice?.finalPrice?.value)
        return <span className={`${prefixClassName} boutik-gatsby-plugin-components-product-price-na`}>{t('na')}</span>;

    return (
        <div
            className={`${
                prefixClassName ?? ""
            } boutik-gatsby-plugin-components-product-price-container ${
                isdiscount ? "on-sale" : ""
            }`}
        >
            <span className="boutik-gatsby-plugin-components-product-price-reg">
                {currentPrice?.regularPrice?.formattedValue}
            </span>
            {isdiscount && (
                <span className="boutik-gatsby-plugin-components-product-price-sale">
                    {currentPrice?.finalPrice.formattedValue}
                </span>
            )}
        </div>
    );
}
